import { render, staticRenderFns } from "./SensorValueLabel.vue?vue&type=template&id=399a2174&scoped=true&"
import script from "./SensorValueLabel.vue?vue&type=script&lang=js&"
export * from "./SensorValueLabel.vue?vue&type=script&lang=js&"
import style0 from "./SensorValueLabel.vue?vue&type=style&index=0&id=399a2174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399a2174",
  null
  
)

export default component.exports